import axios from 'axios';
import toSnakeCaseThenStringify from '@/helpers/toSnakeCaseThenStringify';

export const state = () => ({});

export const getters = {};

export const mutations = {};

export const actions = {
    index(vuexContext, { range, accountId, properties, interval, timeZone, countOnly = false }) {
        const params = {
            range,
            accountId,
            timeZone,
            interval,
            countOnly,
            properties: toSnakeCaseThenStringify(properties)
        };

        return axios.getMethodOverridePost('/v1/dashboard/networks', { params });
    }
};
